import {useEffect, useState} from 'react';
import {useFetchCollectionPreviewRespectCollaborationQuery} from '@api';

export type SelectOption = {label: string; value: string | number};

export type GroupedOption = {
    readonly label: string;
    readonly options: SelectOption[];
};

export const useCollectionGroupedOptions = () => {
    const {data: collectionPreviewsData} =
        useFetchCollectionPreviewRespectCollaborationQuery();

    const [collectionGroupedOptions, setCollectionGroupedOptions] = useState<
        GroupedOption[]
    >([]);

    useEffect(() => {
        if (!collectionPreviewsData) return;

        const groupedOptions: GroupedOption[] = [];

        for (const collection of collectionPreviewsData.entries) {
            const group = groupedOptions.find(
                g => g.label === collection.group
            );
            if (group) {
                group.options.push({
                    label: collection.name,
                    value: collection.id.toString(),
                });
            } else {
                groupedOptions.push({
                    label: collection.group,
                    options: [
                        {
                            label: collection.name,
                            value: collection.id,
                        },
                    ],
                });
            }
        }

        setCollectionGroupedOptions(groupedOptions);
    }, [collectionPreviewsData]);

    return [collectionGroupedOptions];
};
